<script lang="ts">
    import SupportIntro from 'src/components/main/support/components/support-intro/SupportIntro.svelte'
    import Questions from 'src/components/main/support/components/questions/Questions.svelte'
    import SupportTeam from 'src/components/main/support/components/support-team/SupportTeam.svelte'
    import VisitCommunity from 'src/components/main/#common/visit-community/VisitCommunity.svelte'
    import MainLayout from "../#common/layout/Layout.svelte"
</script>

<svelte:head>
    <title>Realis | Support Centre</title>
    <meta name="description" content="We are the world's first platform for launching mobile games using blockchain technologies for a mass audience based on Substrate in Polkadot ecosystem."/>
</svelte:head>

<MainLayout>
    <svelte:fragment slot="content">
        <SupportIntro/>
        <Questions/>
        <SupportTeam/>
        <VisitCommunity/>
    </svelte:fragment>
</MainLayout>
